<template>
    <table id="tables" cellspacing="0" cellpadding="0">
        <tr>
            <th>
                <slot name="first"></slot>
            </th>
            <th>
                <slot name="second"></slot>
            </th>
            <th>
                <slot name="third"></slot>
            </th>
            <th>
                <slot name="fourth"></slot>
            </th>
        </tr>
        <tr>
            <td>1</td>
            <td>Maria Anders</td>
            <td>Germany</td>
            <td class="text-bold">Diterima</td>
        </tr>
        <tr>
            <td>2</td>
            <td>Christina Berglund</td>
            <td>Sweden</td>
            <td class="text-bold">Ditolak</td>
        </tr>
    </table>
</template>

<style lang="scss" scoped>
    #tables {
        border: 1px solid $blue;
        width: 100%;

        th {
            padding-top: 12px;
            padding-bottom: 12px;

            background-color: $blue;
            color: white;
        }

        td,th {
            border-right: 2px solid $blue;
            padding: 8px;
            text-align: center;
            &:last-child{
                border-right: none;
            }
        }
    }

    #tables tr:nth-child(even) {
        background-color: #fff;
    }

    #tables tr:nth-child(odd) {
        background-color: #eff2f9;
    }

    #tables tr:hover {
        background-color: #ddd;
    }
</style>
